export default class InlineSvg {
    static initialize(el) {
        const elementList = document.querySelectorAll(el);

        elementList.forEach(async (img) => {
            const imgID = img.getAttribute('id');
            const imgClass = img.getAttribute('class');
            const imgURL = img.getAttribute('src');
            const imgALT = img.getAttribute('alt');

            let response;

            if (!imgURL || imgURL.length === 0) {
                return;
            }

            try {
                response = await fetch(imgURL);

                if (!response.ok) {
                    throw new Error(response.status);
                }
            } catch (error) {
                console.error(`Could not fetch ${imgURL}: ${error}`);
                return;
            }

            response = await response.text();

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(response, 'text/html');
            const svg = xmlDoc.querySelector('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                svg.setAttribute('id', imgID);
            }
            // Add replaced image's class to the new SVG
            if (typeof imgClass !== 'undefined') {
                svg.setAttribute('class', `${imgClass} replaced-svg`);
            }
            // Add replaced image's alt tags as title to the new SVG
            if (typeof imgALT !== 'undefined') {
                svg.setAttribute('title', imgALT);
            }

            svg.removeAttribute('xmlns:a');

            if (img.parentNode) {
                img.parentNode.replaceChild(svg, img);
            }
        });
    }
}

InlineSvg.initialize('.svg-icon:not(.replaced-svg)');
